import React from "react";
import Drawer from "@mui/material/Drawer";
import { Box, IconButton } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import i18next from "i18next";
import { BasicSelect as TransLang } from "./TransLang";
import CloseIcon from "@mui/icons-material/Close";

export default function NavDrawer({ setDrawer, drawer, logoUrl, pages }) {
    let lng = i18next.language;
    const isRtl = lng === "ar";

    return (
        <Drawer
            anchor={isRtl ? "left" : "right"}
            open={drawer}
            onClose={() => setDrawer(false)}
            sx={{
                ".MuiDrawer-paper": {
                    width: { xs: "85%", sm: "60%" },
                    bgcolor: "rgba(10, 25, 47, 0.98)", // Match navbar background
                    backdropFilter: "blur(20px)",
                    overflowY: "auto",
                    borderLeft: isRtl ? "none" : "1px solid rgba(255, 255, 255, 0.08)",
                    borderRight: isRtl ? "1px solid rgba(255, 255, 255, 0.08)" : "none",
                },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    p: 4,
                    gap: 3,
                    height: "100%",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Link
                        to="/"
                        onClick={() => setDrawer(false)}
                        style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
                    >
                        {logoUrl ? (
                            <Box
                                component="img"
                                src={logoUrl}
                                alt="logo"
                                sx={{ height: 44, width: "auto" }}
                            />
                        ) : (
                            <Box sx={{ color: "#F8FAFC", fontWeight: 700, fontSize: 20 }}>
                                Logo
                            </Box>
                        )}
                    </Link>
                    <IconButton onClick={() => setDrawer(false)} sx={{ color: "#F8FAFC", p: 1 }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, flexGrow: 1 }}>
                    {pages?.map((page, i) => (
                        <NavLink
                            key={i}
                            to={page.path}
                            onClick={() => setDrawer(false)}
                            style={({ isActive }) => ({
                                textDecoration: "none",
                                fontSize: 18,
                                fontWeight: isActive ? 700 : 500,
                                color: isActive ? "#5EB0FF" : "#E5E7EB",
                                padding: "12px 16px",
                                borderRadius: "12px",
                                backgroundColor: isActive ? "rgba(94, 176, 255, 0.1)" : "transparent",
                                transition: "all 0.3s ease",
                                display: "block"
                            })}
                        >
                            {lng === "ar" ? page.name : page.name_en}
                        </NavLink>
                    ))}
                </Box>

                <Box sx={{ mt: "auto", pt: 3, borderTop: "1px solid rgba(255, 255, 255, 0.08)" }}>
                    <TransLang />
                </Box>
            </Box>
        </Drawer>
    );
}
